import {PAGE_MODES} from "./pageMode";

export const filterMedicalOrganizations = ({
  mode,
  medicalOrganizations,
  keyword,
  selectedOrganizationType,
  selectedRegions,
  selectedOnlineReservation,
  selectedFilter,
  selectedMedicalOrganizationId
}) => {
  if (mode === PAGE_MODES.MAP) {
    if  (selectedMedicalOrganizationId)
      return medicalOrganizations.filter(org => org.id === selectedMedicalOrganizationId);
  }
  return medicalOrganizations
    .filter(org => {
      const trimmedKeyword = keyword.trim();
      return (
        (selectedOrganizationType.includes(org.category) || selectedOrganizationType[0] === '不限') &&
        (selectedRegions.includes(org.region) || selectedRegions[0] === '不限') &&
        ((selectedOnlineReservation[0] === '可線上掛號' && org.appointmentWeb) || selectedOnlineReservation[0] === '不限') &&
        (trimmedKeyword === '' || org.name.includes(trimmedKeyword) || org.address.includes(trimmedKeyword))
      )
    })
    .filter(org => {
      return Object.entries(selectedFilter).every(
        ([key, enabled]) => {
          return !enabled || (enabled && org[key])
        }
      )
    })
}